export const LANDING_PAGE_STORAGE_KEY = "wedding_landing_page_config";

export type LandingTimelineItem = {
  id: string;
  time: string;
  title: string;
};

export type LandingImagePosition = {
  x: number;
  y: number;
};

export type LandingImagePositionKey =
  | "logo"
  | "heroCover"
  | "featureImage"
  | "mainPortrait"
  | "invitationImage"
  | "venueImage"
  | "khqrOne"
  | "khqrTwo";

export type LandingElementPositionKey = "logo" | "nameFrame";

export type LandingPageConfig = {
  subtitleKh: string;
  titleKh: string;
  invitationMessage: string;
  groom: string;
  bride: string;
  dateLabel: string;
  timeLabel: string;
  venueKh: string;
  mapUrl: string;
  musicUrl: string;
  thankYouMessage: string;
  images: {
    logo: string;
    heroCover: string;
    featureImage: string;
    mainPortrait: string;
    invitationImage: string;
    venueImage: string;
    khqrOne: string;
    khqrTwo: string;
    gallery: string[];
  };
  imagePositions: Record<LandingImagePositionKey, LandingImagePosition>;
  elementPositions: Record<LandingElementPositionKey, LandingImagePosition>;
  elementSizes: Record<LandingElementPositionKey, number>;
  timeline: LandingTimelineItem[];
};

const pageImage = "/images/own-images/IMG_5836.jpg";
const secondaryPageImage = "/images/own-images/IMG_5735.jpg";
const OLD_VENUE_KH = "ស្រុកឈូក ខេត្តកំពត";
const DEFAULT_VENUE_KH = "ភូមិក្រាំងអំពៅ ឃុំដំណាក់សុក្រំ ស្រុកដងទង់ ខេត្តកំពត";
const DEFAULT_MAP_URL = `https://www.google.com/maps/search/?api=1&query=${DEFAULT_VENUE_KH}`;
const OLD_INVITATION_MESSAGE =
  "យើងខ្ញុំមានកិត្តិយសសូមគោរពអញ្ជើញ ឯកឧត្តម លោកឧកញ៉ា លោកជំទាវ លោក លោកស្រី អ្នកនាងកញ្ញា អញ្ជើញចូលរួមជាអធិបតី និងជាភ្ញៀវកិត្តិយស ដើម្បីប្រសិទ្ធិពរជ័យសិរីសួស្តី ជ័យមង្គល ក្នុងពិធីអាពាហ៍ពិពាហ៍របស់យើងខ្ញុំទាំងពីរ។";
const DEFAULT_INVITATION_MESSAGE =
  "ឯកឧត្តម លោកឧកញ៉ា លោកជំទាវ លោក លោកស្រី និងអ្នកនាងកញ្ញា មេត្តាផ្តល់កិត្តិយសអញ្ជើញចូលរួមក្នុងពិធីអាពាហ៍ពិពាហ៍ របស់យើងខ្ញុំទាំងពីរ ដើម្បីចូលរួមជាអធិបតី និងជាសាក្សីនៃក្តីស្នេហ៍ ព្រមទាំងប្រសិទ្ធពរជ័យសិរីមង្គលមហាប្រសើរ ដល់គូស្វាមីភរិយាថ្មី";

export const DEFAULT_LANDING_PAGE_CONFIG: LandingPageConfig = {
  subtitleKh: "សូមគោរពអញ្ជើញ",
  titleKh: "សិរីមង្គលអាពាហ៍ពិពាហ៍",
  invitationMessage: DEFAULT_INVITATION_MESSAGE,
  groom: "វុឌ្ឍន៏ សច្ចះបូរមី",
  bride: "ខែម និមល",
  dateLabel: "ថ្ងៃសុក្រ ទី១៤ ខែឧសភា ឆ្នាំ២០២៧",
  timeLabel: "ពិធីទទួលភ្ញៀវចាប់ផ្តើមនៅម៉ោង ៥:០០ ល្ងាច",
  venueKh: DEFAULT_VENUE_KH,
  mapUrl: DEFAULT_MAP_URL,
  musicUrl:
    "https://cdn.theapka.com/music/Kou_Pi_Preng_Prutt-Him_Sivorn_Ft_Ek_Side.mp3",
  thankYouMessage:
    "វត្តមានរបស់លោកអ្នក ជាកិត្តិយសដ៏ឧត្តុង្គឧត្តមចំពោះគ្រួសាររបស់យើងខ្ញុំ។ សូមជូនពរឱ្យលោកអ្នក និងក្រុមគ្រួសារ ប្រកបដោយសុខភាពល្អ សុភមង្គល និងសេចក្តីរីកចម្រើនជានិច្ច។",
  images: {
    logo: "/images/logo/logo4.png",
    heroCover: pageImage,
    featureImage: pageImage,
    mainPortrait: secondaryPageImage,
    invitationImage: pageImage,
    venueImage: secondaryPageImage,
    khqrOne: pageImage,
    khqrTwo: pageImage,
    gallery: [
      pageImage,
      secondaryPageImage,
      pageImage,
      secondaryPageImage,
      pageImage,
      secondaryPageImage,
    ],
  },
  imagePositions: {
    logo: { x: 50, y: 50 },
    heroCover: { x: 50, y: 50 },
    featureImage: { x: 50, y: 50 },
    mainPortrait: { x: 50, y: 50 },
    invitationImage: { x: 50, y: 50 },
    venueImage: { x: 50, y: 50 },
    khqrOne: { x: 50, y: 50 },
    khqrTwo: { x: 50, y: 50 },
  },
  elementPositions: {
    logo: { x: 12, y: 8 },
    nameFrame: { x: 50, y: 68 },
  },
  elementSizes: {
    logo: 74,
    nameFrame: 68,
  },
  timeline: [
    { id: "1", time: "06:30", title: "ជួបជុំភ្ញៀវកិត្តិយស" },
    {
      id: "2",
      time: "07:00",
      title: "ជួបជុំភ្ញៀវកិត្តិយសរៀបចំពិធីហែជំនូននៅគេហដ្ឋានកូនស្រី",
    },
    {
      id: "3",
      time: "07:30",
      title: "ពិធីហែជំនូន ចូលរោងជ័យ និងអញ្ជើញភ្ញៀវកិត្តិយសពិសារអាហារពេលព្រឹក",
    },
    { id: "4", time: "08:15", title: "ពិធីជូនបណ្ណាការ ពិសារស្លា និងបំពាក់ជញ្ជៀន" },
    { id: "5", time: "09:00", title: "ពិធិកាត់សក់ បង្កក់សិរី កូនប្រុស កូនស្រី" },
    { id: "6", time: "11:00", title: "ពិធីសំពះផ្ទឹមចងដៃ បង្វិលពពិល និងព្រះថោងតោងស្បៃ" },
    { id: "7", time: "12:00", title: "អញ្ជើញភ្ញៀវកិត្តិយសពិសារអាហារថ្ងៃត្រង់" },
    { id: "8", time: "17:00", title: "អញ្ជើញភ្ញៀវកិត្តិយសពិសារភោជនាហារ" },
  ],
};

type LandingPageConfigInput = Partial<
  Omit<LandingPageConfig, "images" | "imagePositions" | "elementPositions" | "elementSizes" | "timeline"> & {
    images?: Partial<LandingPageConfig["images"]>;
    imagePositions?: Partial<LandingPageConfig["imagePositions"]>;
    elementPositions?: Partial<LandingPageConfig["elementPositions"]>;
    elementSizes?: Partial<LandingPageConfig["elementSizes"]>;
    timeline?: Array<Partial<LandingTimelineItem>>;
  }
>;

export const mergeLandingPageConfig = (
  input?: LandingPageConfigInput | null,
): LandingPageConfig => {
  const inputInvitationMessage = input?.invitationMessage?.trim();
  const inputVenueKh = input?.venueKh?.trim();
  const inputMapUrl = input?.mapUrl?.trim();
  const mergedTimeline = DEFAULT_LANDING_PAGE_CONFIG.timeline.map((item, index) => ({
    ...item,
    ...(input?.timeline?.[index] ?? {}),
  }));

  if ((input?.timeline?.length ?? 0) > DEFAULT_LANDING_PAGE_CONFIG.timeline.length) {
    input?.timeline?.slice(DEFAULT_LANDING_PAGE_CONFIG.timeline.length).forEach((item, index) => {
      mergedTimeline.push({
        id: item.id ?? `extra-${index + 1}`,
        time: item.time ?? "",
        title: item.title ?? "",
      });
    });
  }

  return {
    ...DEFAULT_LANDING_PAGE_CONFIG,
    ...input,
    invitationMessage:
      !inputInvitationMessage || inputInvitationMessage === OLD_INVITATION_MESSAGE
        ? DEFAULT_INVITATION_MESSAGE
        : inputInvitationMessage,
    venueKh: !inputVenueKh || inputVenueKh === OLD_VENUE_KH ? DEFAULT_VENUE_KH : inputVenueKh,
    mapUrl: !inputMapUrl || inputVenueKh === OLD_VENUE_KH ? DEFAULT_MAP_URL : inputMapUrl,
    images: {
      ...DEFAULT_LANDING_PAGE_CONFIG.images,
      ...(input?.images ?? {}),
      gallery:
        input?.images?.gallery?.filter((item): item is string => typeof item === "string" && item.length > 0) ??
        DEFAULT_LANDING_PAGE_CONFIG.images.gallery,
    },
    imagePositions: {
      ...DEFAULT_LANDING_PAGE_CONFIG.imagePositions,
      ...(input?.imagePositions ?? {}),
    },
    elementPositions: {
      ...DEFAULT_LANDING_PAGE_CONFIG.elementPositions,
      ...(input?.elementPositions ?? {}),
    },
    elementSizes: {
      ...DEFAULT_LANDING_PAGE_CONFIG.elementSizes,
      ...(input?.elementSizes ?? {}),
    },
    timeline: mergedTimeline,
  };
};
